import { storage } from '@abyss/ui/tools/storage';
import { config } from '@abyss/ui/tools/config';

export const redirectHandler = () => {
  const redirect = storage.session.get('redirect');
  window.location = decodeURIComponent(redirect || config('SDE_URL'));
};
